import { styled, InputLabel as InputLabelMui } from '@mui/material';

export const InputLabel = styled(InputLabelMui)(({ theme, readOnly }) => ({
  cursor: readOnly ? 'auto' : 'pointer',
  whiteSpace: 'nowrap',
  color: readOnly ? 'rgba(0, 0, 0, 0.54)' : '#9494A3',
  fontSize: 14,
  lineHeight: '16px',
  '&.Mui-required > *[class*="asterisk"]': {
    color: theme.status.button.negative.default,
  },
  ...(readOnly && {
    '& > *[class*="asterisk"]': {
      display: 'none',
    },
  }),
}));
